import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/discoveryFilled.svg';

export const IconDiscoveryFilled = createIconComponent(Icon);
